export const MEETING_TEXT = {
  en_GB: {
    meetingRoom: "Meeting room",
    meetingRoomHelp: "Generate a video meeting link (only for future meetings)",
    meetingRoomRemoveHelp: "Unticking deletes the room in Whereby; shared links stop working.",
    removeRoomTitle: "Delete the meeting room?",
    removeRoomConfirmation:
      "The room is deleted in Whereby and the guest and host links already shared stop working. Ticking the box again creates a new room with new links.",
    removeRoom: "Delete room",
    duration: "Duration (minutes)",
    hostLink: "Host link",
    guestLink: "Guest link",
    fetchTranscription: "Fetch transcription",
    retranscribe: "Re-transcribe",
    storedLanguage: "Stored",
    transcriptionEmpty: "No transcription available yet.",
    transcriptionInProgress:
      "Whereby is still processing the transcription. Try again in a few minutes.",
    transcriptionFailed: "Whereby reported the transcription failed.",
    transcriptionNoRecording:
      "No recording yet. The transcription will appear after the call is recorded.",
    transcriptionTitle: "Transcription",
    futureOnly: "Disabled — meeting is in the past",
  },
  nb_NO: {
    meetingRoom: "Møterom",
    meetingRoomHelp: "Generer en videolenke (kun for fremtidige møter)",
    meetingRoomRemoveHelp:
      "Fjerner du haken, slettes rommet i Whereby og delte lenker slutter å virke.",
    removeRoomTitle: "Slette møterommet?",
    removeRoomConfirmation:
      "Rommet slettes i Whereby, og gjeste- og vertslenkene som allerede er delt slutter å virke. Setter du haken igjen, lages et nytt rom med nye lenker.",
    removeRoom: "Slett rom",
    duration: "Varighet (minutter)",
    hostLink: "Vert-lenke",
    guestLink: "Gjeste-lenke",
    fetchTranscription: "Hent transkripsjon",
    retranscribe: "Transkriber på nytt",
    storedLanguage: "Lagret språk",
    transcriptionEmpty: "Ingen transkripsjon tilgjengelig ennå.",
    transcriptionInProgress:
      "Whereby behandler fortsatt transkripsjonen. Prøv igjen om noen minutter.",
    transcriptionFailed: "Whereby rapporterte at transkripsjonen feilet.",
    transcriptionNoRecording:
      "Ingen opptak ennå. Transkripsjonen kommer etter at samtalen er tatt opp.",
    transcriptionTitle: "Transkripsjon",
    futureOnly: "Deaktivert — møtet er i fortiden",
  },
} as const;

export const T = {
  en_GB: {
    deleteTitle: "Delete entry",
    deleteConfirmation: (title: string) =>
      `Are you sure you want to delete "${title}"? This action cannot be undone.`,
    delete: "Delete",
    cancel: "Cancel",
    topicRequired: "Topic is required",
    failedToUpdate: "Failed to update",
    failedToCreate: "Failed to create",
    topic: "Topic",
    date: "Date",
    content: "Content",
    enterTopic: "Enter topic",
    writeHere: "Write your notes here...",
    saving: "Saving...",
    saved: "Saved",
    save: "Save",
    backToList: "Back",
  },
  nb_NO: {
    deleteTitle: "Slett oppføring",
    deleteConfirmation: (title: string) =>
      `Er du sikker på at du vil slette "${title}"? Denne handlingen kan ikke angres.`,
    delete: "Slett",
    cancel: "Avbryt",
    topicRequired: "Tema er påkrevd",
    failedToUpdate: "Kunne ikke oppdatere",
    failedToCreate: "Kunne ikke opprette",
    topic: "Tema",
    date: "Dato",
    content: "Innhold",
    enterTopic: "Skriv inn tema",
    writeHere: "Skriv notatene dine her...",
    saving: "Lagrer...",
    saved: "Lagret",
    save: "Lagre",
    backToList: "Tilbake",
  },
} as const;
